import type { InternalNetworkAttackPathEventDto } from '@terra/shared-contracts-internal-network';

const YIELD_KINDS = new Set(['CREDENTIAL_OBTAINED', 'IMPACT_ACHIEVED']);

const resolveHopKey = (event: InternalNetworkAttackPathEventDto): string =>
  [event.hopIndex ?? '', event.technique ?? ''].join('\0');

export const dropAttackPathFailedHopYields = (
  events: InternalNetworkAttackPathEventDto[],
): InternalNetworkAttackPathEventDto[] => {
  const weaknessStatuses = new Map<
    string,
    Set<InternalNetworkAttackPathEventDto['status']>
  >();

  for (const event of events) {
    if (event.kind !== 'WEAKNESS_EXPLOITED' || !event.exploitsWeakness) {
      continue;
    }

    const key = resolveHopKey(event);
    const statuses = weaknessStatuses.get(key) ?? new Set();

    statuses.add(event.status);
    weaknessStatuses.set(key, statuses);
  }

  const failedHopKeys = new Set(
    [...weaknessStatuses.entries()]
      .filter(([, statuses]) => !statuses.has('SUCCEEDED'))
      .map(([key]) => key),
  );

  if (failedHopKeys.size === 0) {
    return events;
  }

  return events.filter((event) => {
    if (!YIELD_KINDS.has(event.kind)) {
      return true;
    }

    return !failedHopKeys.has(resolveHopKey(event));
  });
};
